import { FC, lazy } from 'react';
import { useParams } from 'react-router-dom';
import { PageSpinner } from 'src/components/spinner-container';
import { useExternalTrade } from 'src/pages/reporting/secondary-tradings/external-trades/details/use-external-trade';
import { useRemitReportHistory } from 'src/pages/reporting/secondary-tradings/overview/remit-reports/use-remit-report-history';
import { useOrganisationServicePublic } from 'src/pages/settings/organisation/use-organisation-service-public';

const Page = lazy(() => import('./page'));

export const ExternalTradeDetails: FC = () => {
  const { externalTradeId } = useParams<{
    externalTradeId: string;
  }>();
  const externalTradeRequest = useExternalTrade(externalTradeId);
  const remitReportHistoryRequest = useRemitReportHistory(externalTradeId);
  const organisationService = useOrganisationServicePublic();

  if (
    !externalTradeRequest.response ||
    !remitReportHistoryRequest?.response ||
    !organisationService?.response
  )
    return <PageSpinner />;

  return (
    <Page
      externalTradeId={externalTradeId}
      externalTrade={externalTradeRequest.response.data}
      remitReportHistory={remitReportHistoryRequest.response.data}
      organisationServiceLinks={organisationService.response.data}
    />
  );
};
